export enum ModulesTypesEnum {
  Live = 'live',
  TvShows = 'tvshows',
}

export type Modules = ModulesTypesEnum[]
